<div class="w-full h-full fixed block top-0 left-0 bg-gray-700 opacity-75 z-50" *ngIf="loading">
    <span class="text-gray-300 top-1/2 my-0 mx-auto block relative w-0 h-0">
      <i class="fas fa-spinner animate-spin text-8xl"></i>
    </span>
  </div>